import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientStudentManagementConfig = async (
  { rootGetters, commit },
  { clientSid, queryParam }
) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.getClientStudentManagementConfig(clientSid, queryParam);
  if (response) {
    commit('setClientStudentManagement', response);
  }
  return response;
};
